/**
 * Decorative UI icon rendered as a plain character.
 *
 * Deliberately bypasses EmojiText: interface chrome (buttons, chips, badges)
 * stays still and resolves through the SerenityOS pixel font declared at the
 * head of every font stack, so it matches the pixel-art theme. EmojiText — and
 * with it the Noto Lottie animation — remains for emoji that are game content.
 *
 * Hidden from assistive technology by default, on the assumption that the
 * surrounding control carries its own accessible name. Pass `label` for the
 * cases where the icon stands alone and therefore *is* the name.
 */

interface PixelIconProps {
  /** A single emoji character. */
  children: string
  /** Sizing utilities, e.g. "text-2xl". */
  className?: string
  /** Accessible name; set only when no adjacent text describes the icon. */
  label?: string
}

export function PixelIcon({ children, className = '', label }: PixelIconProps) {
  if (label !== undefined) {
    return (
      <span role="img" aria-label={label} className={className}>
        {children}
      </span>
    )
  }

  return (
    <span aria-hidden="true" className={className}>
      {children}
    </span>
  )
}
